(function ($, Drupal, drupalSettings) {
  "use strict";

  $("body .paragraph").each(function () {
    var html = $(this).html();
    $(this).html(html.replace(/&nbsp;/g, ""));
  });

  /* 
  | ----------------------------
  | Header 
  | ----------------------------
  */
  if ($("body").hasClass("user-logged-in")) {
    headerHeight = $("header").outerHeight() + 20 + "px";
    menuHeight = $("header").outerHeight() + 80 + "px";
  } else {
    var headerHeight = $("header").outerHeight() - 2 + "px";
    menuHeight = $("header").outerHeight();
  }
  // $("main").css("padding-top", headerHeight);
  //Header colors & paddings if no image is present in hero banner
  $(
    ".path-clients main, .path-blog main, .path-case-studies main, .page-node-type-case-study main, .page-node-type-testimonial main, .page-node-type-client main, .error-page main",
  ).css("padding-top", headerHeight);

  if ($(".taxonomy__top").find(".field-field-media").length) {
    $(".path-taxonomy main").css("padding-top", 0);
  } else {
    $(".path-taxonomy main").css("padding-top", headerHeight);
    $(".path-taxonomy .logo-case-studies").css("display", "block");
    $(".path-taxonomy .logo-main").css("display", "none");
    $(
      ".path-taxonomy .block-we-megamenu-blockmain>.region-we-mega-menu>.main.navbar>.container-fluid>.we-mega-menu-ul>.we-mega-menu-li",
    ).addClass("black");
    $(".path-taxonomy .burger__line").css("background-color", "black");
  }

  if ($(".page-title-container").find("img, video").length) {
    $(".path-taxonomy main").css("padding-top", 0);
  } else {
    if (!$("body").hasClass("path-frontpage")) {
      $(".page-node-type-page main").css("padding-top", headerHeight);
      $(".page-node-type-page .logo-case-studies").css("display", "block");
      $(".page-node-type-page .logo-main").css("display", "none");
      $(
        ".page-node-type-page .block-we-megamenu-blockmain>.region-we-mega-menu>.main.navbar>.container-fluid>.we-mega-menu-ul>.we-mega-menu-li",
      ).addClass("black");
      $(".page-node-type-page .burger__line").css("background-color", "black");
    }
  }

  $(".path-user main").css("padding-top", headerHeight);

  $(".sticky-links").hide();
  if ($(window).width() >= 1024) {
    $(".we-mega-menu-li.dropdown-menu, .we-mega-menu-submenu").on(
      "mouseenter",
      function () {
        $("header").addClass("scrolled");
      },
    );

    $(".we-mega-menu-li.dropdown-menu, .we-mega-menu-submenu").on(
      "mouseover",
      function () {
        $("header").addClass("scrolled");
      },
    );

    $(".we-mega-menu-li.dropdown-menu, .we-mega-menu-submenu").on(
      "mouseleave",
      function () {
        if ($(window).scrollTop() <= 50) {
          $("header").removeClass("scrolled");
        }
      },
    );
  }

  // $(window).on("scroll", function () {
  //   if ($(this).scrollTop() > 50) {
  //     $("header").addClass("scrolled");
  //   } else {
  //     $("header").removeClass("scrolled");
  //   }
  // });

  $(window).on("scroll", function () {
    if ($(this).scrollTop() > 50) {
      $("header").addClass("scrolled");
    } else {
      if (!$("body").hasClass("open-menu")) {
        $("header").removeClass("scrolled");
      }
    }
  });

  $(
    "header .header-container .main-navigation>.menu>.menu-item--expanded>.menu",
  ).css("top", menuHeight);

  if ($(window).width() <= 1024) {
    $(".main-navigation>.menu>.menu-item--expanded>span").on(
      "click",
      function () {
        $(this).siblings(".menu").toggleClass("active");
      },
    );
    $(".user-toggle").on("click", function () {
      $(this).parent().toggleClass("active");
      $("body").removeClass("open-menu");
      $(".rkpt-search-form").removeClass("active");
    });
    $(".main-navigation").css("top", headerHeight);
    $(".mobile-main-navigation").css("top", headerHeight);
  }
  if ($(window).width() <= 1024) {
    $(".rkpt-search-form").css("top", headerHeight);
  }

  //Mobile menu
  $(function () {
    $(".burger").on("click", function () {
      $("body").toggleClass("open-menu");
      $(
        ".mobile-main-navigation .menu-level-1, .mobile-main-navigation .menu-level-2",
      ).hide();
      $("header").addClass("scrolled");
      $(".rkpt-search-form").removeClass("active");
      $(".account").removeClass("active");
    });

    $(".mobile-main-navigation .menu-level-1, .menu-level-2").hide();

    $(".mobile-main-navigation").on(
      "click",
      ".menu-item--expanded > span",
      function (e) {
        e.stopPropagation();

        const parentTitle = $(this).text();
        const submenu = $(this).siblings(
          ".mobile-main-navigation .menu-level-1",
        );

        $(".mobile-main-navigation .menu-level-1").not(submenu).hide();
        submenu.toggle();

        if (
          submenu.is(":visible") &&
          submenu.find(".parent-title").length === 0
        ) {
          const parentTitleItem = $(
            '<li class="parent-title"><span>' + parentTitle + "</span></li>",
          );
          submenu.prepend(parentTitleItem);
        }

        $(".mobile-main-navigation .menu-level-1").css("top", headerHeight);
      },
    );

    $(".mobile-main-navigation").on(
      "click",
      ".menu-level-1 .parent-title",
      function () {
        const submenu = $(this).closest(".menu-level-1");

        submenu.hide();
        $(this).remove();
      },
    );

    $(".mobile-main-navigation").on(
      "click",
      ".menu-level-1 > .menu-item--expanded > a",
      function (e) {
        e.preventDefault();

        $(this).parent().siblings().find("a").removeClass("active");
        $(this).toggleClass("active");

        const subSubmenu = $(this).siblings(
          ".mobile-main-navigation .menu-level-2",
        );

        $(".mobile-main-navigation .menu-level-2").not(subSubmenu).slideUp();
        subSubmenu.slideToggle();
      },
    );
  });

  /* 
  | ----------------------------
  | Search form  
  | ----------------------------
  */
  $(".search-toggle").on("click", function () {
    $(".block-rkpt-search-form-block").toggleClass("active");
    $("body").removeClass("open-menu");
    $(".account").removeClass("active");
  });

  /* 
  | ----------------------------
  | Swiper setup
  | ----------------------------
  */

  function setupSwiper(width, element, options) {
    // breakpoint where swiper will be destroyed
    var breakpoint = window.matchMedia("(min-width:" + width + ")");

    // keep track of swiper instances to destroy later
    var mySwiper;

    var breakpointChecker = function () {
      // if larger viewport and multi-row layout needed
      if (breakpoint.matches) {
        // clean up old instances and inline styles when available
        if (mySwiper !== undefined) {
          mySwiper.destroy(true, true);
          // or/and do nothing
          return;
        }

        // else if a small viewport and double column layout needed
      } else {
        // fire small viewport version of swiper
        return enableSwiper();
      }
    };

    var enableSwiper = function () {
      mySwiper = new Swiper(element, options);
    };

    // keep an eye on viewport size changes
    breakpoint.addListener(breakpointChecker);

    // kickstart
    breakpointChecker();
  }

  $(".testimonial-images-slider").each(function () {
    if ($(".testimonial-images-slider .swiper-wrapper").children().length) {
      setupSwiper("", ".testimonial-images-slider", {
        slidesPerView: 1.2,
        spaceBetween: 20,
      });
    }
  });

  $(".testimonial-front-slider").each(function () {
    if ($(".testimonial-front-slider .swiper-wrapper").children().length) {
      setupSwiper("", ".testimonial-front-slider", {
        slidesPerView: 2.6,
        spaceBetween: 20,
        breakpoints: {
          0: {
            spaceBetween: 10,
            slidesPerView: 1.2,
          },
          901: {
            slidesPerView: 1.8,
          },
          1025: {
            slidesPerView: 2.6,
          },
        },
      });
    }
  });

  $(".case-studies-swiper").each(function () {
    if ($(".case-studies-swiper .swiper-wrapper").children().length) {
      setupSwiper("", ".case-studies-swiper", {
        slidesPerView: 2.6,
        spaceBetween: 20,
        breakpoints: {
          0: {
            spaceBetween: 10,
            slidesPerView: 1.2,
          },
          901: {
            slidesPerView: 2.2,
          },
          1025: {
            slidesPerView: 3.2,
          },
        },
      });
    }
  });

  $(".front-news-swiper").each(function () {
    if ($(".front-news-swiper .swiper-wrapper").children().length) {
      setupSwiper("", ".front-news-swiper", {
        slidesPerView: 1.2,
        spaceBetween: 20,
        breakpoints: {
          0: {
            spaceBetween: 10,
            slidesPerView: 1.2,
          },
          901: {
            slidesPerView: 1.8,
          },
          1025: {
            slidesPerView: 3,
          },
        },
      });
    }
  });

  //GSAP animation for view component's sliders

  const allAnimatedParagraphs = document.querySelectorAll(
    ".paragraph--type--view-component.has-gsap-animation",
  );

  if (allAnimatedParagraphs.length) {
    if (typeof gsap !== "undefined") {
      gsap.registerPlugin(ScrollTrigger);

      const preHideElements = () => {
        allAnimatedParagraphs.forEach((section) => {
          const title = section.querySelector(".field-field-title");
          const body = section.querySelector(".field-field-body");
          const slides = section.querySelectorAll(".swiper-slide");
          const elementsToHide = [title, body, ...slides].filter(Boolean);

          gsap.set(elementsToHide, {
            autoAlpha: 0,
            y: 30,
          });
        });
      };

      preHideElements();

      const initSectionAnimation = (section) => {
        const title = section.querySelector(".field-field-title");
        const body = section.querySelector(".field-field-body");
        const swiperContainer = section.querySelector(".swiper");

        if (!swiperContainer) return;

        if (swiperContainer.classList.contains("case-studies-swiper")) {
          new Swiper(swiperContainer, {
            slidesPerView: 2.6,
            spaceBetween: 20,
            breakpoints: {
              0: { slidesPerView: 1.2, spaceBetween: 10 },
              901: { slidesPerView: 2.2 },
              1025: { slidesPerView: 3.2 },
            },
          });
        } else if (swiperContainer.classList.contains("front-news-swiper")) {
          new Swiper(swiperContainer, {
            slidesPerView: 1.2,
            spaceBetween: 20,
            breakpoints: {
              0: { slidesPerView: 1.2, spaceBetween: 10 },
              901: { slidesPerView: 1.8 },
              1025: { slidesPerView: 3 },
            },
          });
        }

        const slides = swiperContainer.querySelectorAll(".swiper-slide");

        const tl = gsap.timeline({ defaults: { ease: "power2.out" } });

        tl.to([title, body], {
          autoAlpha: 1,
          y: 0,
          duration: 1.2,
          stagger: 0.25,
        }).to(
          slides,
          { autoAlpha: 1, y: 0, stagger: 0.18, duration: 1 },
          "-=0.5",
        );
      };

      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              initSectionAnimation(entry.target);
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.2, rootMargin: "0px 0px -10% 0px" },
      );

      allAnimatedParagraphs.forEach((section) => observer.observe(section));
    } else {
      console.warn("GSAP is not loaded but elements require animation.");
    }
  }

  ///////////////////////////

  $(".testimonials-swiper").each(function () {
    if ($(".testimonials-swiper .swiper-wrapper").children().length) {
      setupSwiper("", ".testimonials-swiper", {
        slidesPerView: 2.2,
        spaceBetween: 20,
        breakpoints: {
          0: {
            spaceBetween: 10,
            slidesPerView: 1.2,
          },
          901: {
            slidesPerView: 1.8,
          },
          1025: {
            slidesPerView: 2.2,
          },
        },
      });
    }
  });

  $(".offices-images-slider").each(function () {
    if ($(".offices-images-slider .swiper-wrapper").children().length) {
      setupSwiper("", ".offices-images-slider", {
        slidesPerView: 1,
        spaceBetween: 20,
        hashNavigation: {
          watchState: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    }
  });

  $(".info-cards-slider").each(function () {
    const $slider = $(this);
    const $wrapper = $slider.find(".swiper-wrapper");
    const slideCount = $wrapper.children().length;
    const windowWidth = $(window).width();

    if ($(".info-cards-slider .swiper-wrapper").children().length) {
      setupSwiper("", ".info-cards-slider", {
        slidesPerView: 3,
        spaceBetween: 20,
        centerInsufficientSlides: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          0: {
            spaceBetween: 10,
            slidesPerView: 1,
          },
          901: {
            slidesPerView: 1.5,
          },
          1025: {
            slidesPerView: 3,
          },
        },
      });
    }

    if (windowWidth >= 1025 && slideCount <= 3) {
      $slider.find(".swiper-button-next, .swiper-button-prev").hide();
      $slider.addClass("no-margin");
    }
  });

  $(".interviews-slider").each(function () {
    const $slider = $(this);
    const $wrapper = $slider.find(".swiper-wrapper");
    const slideCount = $wrapper.children().length;
    const windowWidth = $(window).width();

    if ($(".interviews-slider .swiper-wrapper").children().length) {
      setupSwiper("", ".interviews-slider", {
        slidesPerView: 3,
        spaceBetween: 20,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          0: {
            spaceBetween: 10,
            slidesPerView: 1,
          },
          901: {
            slidesPerView: 1.5,
          },
          1025: {
            slidesPerView: 3,
          },
          1400: {
            slidesPerView: 4,
          },
        },
      });
    }

    if (windowWidth >= 1400 && slideCount <= 4) {
      $slider.find(".swiper-button-next, .swiper-button-prev").hide();
    }
  });

  if ($(window).width() <= 767) {
    $(".image-grid-slider").each(function () {
      if ($(".image-grid-slider .swiper-wrapper").children().length) {
        setupSwiper("", ".image-grid-slider", {
          slidesPerView: 1.2,
          spaceBetween: 12,
        });
      }
    });
  }

  /* 
  | ----------------------------
  | Animations 
  | ----------------------------
  */

  $(function () {
    let countersBuilt = false;
    let countersAnimated = false;

    function buildCounters() {
      $(".paragraph--type--single-metric .counter-container").each(function () {
        const $counter = $(this);
        const targetRaw = String($counter.data("target"));

        let prefix = "";
        let suffix = "";
        let target = targetRaw;

        if (targetRaw.startsWith("+")) {
          prefix = "+";
          target = targetRaw.substring(1);
        } else if (targetRaw.endsWith("+")) {
          suffix = "+";
          target = targetRaw.substring(0, targetRaw.length - 1);
        }

        const numericTarget = parseInt(target, 10);
        const formattedTarget = new Intl.NumberFormat("de-DE").format(
          numericTarget,
        );

        $counter.empty().css({
          display: "inline-flex",
          "align-items": "center",
          gap: "0",
          width: "fit-content",
          "justify-content": "flex-start",
        });

        if (prefix) {
          $("<span>").addClass("symbol prefix").text(prefix).appendTo($counter);
        }

        formattedTarget.split("").forEach((char) => {
          if (/\d/.test(char)) {
            const $wrapper = $("<div>")
              .addClass("digit-wrapper")
              .css({ display: "inline-block" });
            const $scroller = $("<div>").addClass("digit-scroller");
            for (let i = 0; i <= 9; i++) {
              $("<span>").text(i).appendTo($scroller);
            }
            $wrapper.append($scroller).appendTo($counter);
          } else {
            $("<span>").addClass("symbol").text(char).appendTo($counter);
          }
        });

        if (suffix) {
          $("<span>").addClass("symbol suffix").text(suffix).appendTo($counter);
        }
      });

      countersBuilt = true;
    }

    function animateCounters() {
      $(".counter-container:not(.animated)").each(function () {
        const $counter = $(this);
        $counter.addClass("animated");

        const targetRaw = String($counter.data("target"));
        const numericTarget = parseInt(targetRaw.replace(/\+/g, ""), 10);
        const formattedTarget = new Intl.NumberFormat("de-DE").format(
          numericTarget,
        );

        let digitIndex = 0;
        formattedTarget.split("").forEach((char, stringIndex) => {
          if (/\d/.test(char)) {
            const $scroller = $counter.find(".digit-scroller").eq(digitIndex);
            const targetDigit = parseInt(char, 10);
            const emSize = parseFloat($counter.css("font-size")) || 16;
            const offset = -targetDigit * emSize;
            const delay = stringIndex * 100;

            setTimeout(() => {
              $scroller.css({
                transform: `translateY(${offset}px)`,
                transition: "transform 0.8s ease-out",
              });

              if (targetDigit === 1) {
                $scroller.closest(".digit-wrapper").addClass("is-one");
              }
            }, delay);

            digitIndex++;
          }
        });
      });

      countersAnimated = true;
    }

    $(window).on("scroll resize load", function () {
      const $section = $(".paragraph--type--key-metrics");
      if (!$section.length) return;

      const windowTop = $(window).scrollTop();
      const windowHeight = $(window).height();
      const sectionTop = $section.offset().top;
      const sectionHeight = $section.outerHeight();

      if (windowTop + windowHeight > sectionTop + sectionHeight / 4) {
        if (!countersBuilt) buildCounters();
        // if (!countersAnimated) setTimeout(animateCounters, 200);
        if (!countersAnimated) {
          const delay = $section.hasClass("has-animation") ? 650 : 200;
          setTimeout(animateCounters, delay);

          // console.log(delay);
        }
      }
    });
  });

  $(
    ".paragraph--type--text-on-both-sides.has-animation-left .paragraph__wrapper .paragraph__wrapper--left .field-field-text",
  ).each(function () {
    var $this = $(this);
    var aboutContainer = $this.offset().top;

    $(window).on("scroll", function () {
      var windowHeight = $(window).height();
      var scrollPosition = $(window).scrollTop() + windowHeight - 100;

      if (aboutContainer < scrollPosition) {
        $this.addClass("animate");
      } else {
        $this.removeClass("animate");
      }
    });
  });

  $(".has-animation .paragraph__wrapper")
    .not(".path-frontpage .paragraph--type--cta-banner .paragraph__wrapper")
    .each(function () {
      var $this = $(this);
      var aboutContainer = $this.offset().top;

      $(window).on("scroll", function () {
        var windowHeight = $(window).height();
        var scrollPosition = $(window).scrollTop() + windowHeight - 200;

        if (aboutContainer < scrollPosition) {
          $this.addClass("animate");
        }
      });
    });

  $(".path-frontpage .paragraph--type--cta-banner .paragraph__wrapper").each(
    function () {
      var $this = $(this);
      var aboutContainer = $this.offset().top;

      $(window).on("scroll", function () {
        var windowHeight = $(window).height();
        var scrollPosition = $(window).scrollTop() + windowHeight - 200;

        if (aboutContainer < scrollPosition) {
          setTimeout(function () {
            $this.addClass("animate");
          }, 550);
        }
      });
    },
  );

  // $(
  //   ".paragraph--type--text-on-both-sides .paragraph__wrapper .paragraph__wrapper--left"
  // ).each(function () {
  //   var $this = $(this);
  //   var aboutContainer = $this.offset().top;

  //   console.log("Video offset (aboutContainer):", aboutContainer);

  //   $(this)
  //     .find("video")
  //     .prop({
  //       autoplay: true,
  //       loop: true,
  //       muted: true,
  //       playsinline: true,
  //     })
  //     .removeAttr("controls")[0];

  //   $(window).on("scroll", function () {
  //     var windowHeight = $(window).height();
  //     var scrollPosition = $(window).scrollTop() + windowHeight;

  //     if (aboutContainer < scrollPosition) {
  //       $this.addClass("animate-video");

  //       const $video = $this.find("video").get(0);
  //       if ($video && $video.paused) {
  //         $video.play().catch((e) => {});
  //       }
  //     } else {
  //       const $video = $this.find("video").get(0);
  //       if ($video && !$video.paused) {
  //         $video.pause();
  //       }
  //     }
  //   });
  // });

  $(document).ready(function () {
    const $targetParagraphs = $(
      ".paragraph--type--text-on-both-sides .paragraph__wrapper .paragraph__wrapper--left",
    );
    const videoElements = [];

    $targetParagraphs.each(function () {
      const $this = $(this);
      const $video = $this.find("video");

      $video
        .prop({
          autoplay: false,
          loop: true,
          muted: true,
          playsinline: true,
        })
        .removeAttr("controls");

      videoElements.push({
        $container: $this,
        $video: $video.get(0),
        initialOffsetTop: $this.offset().top,
      });
    });

    function handleVideoPlaybackOnScroll() {
      const windowHeight = $(window).height();
      const scrollTop = $(window).scrollTop();
      const isMobile = window.innerWidth < 768;
      const triggerOffset = isMobile ? 200 : 400;

      videoElements.forEach(function (obj) {
        const $container = obj.$container;
        const $video = obj.$video;

        const containerTop = $container.offset().top;
        const containerBottom = containerTop + $container.outerHeight();
        const triggerPoint = scrollTop + windowHeight - triggerOffset;

        if (containerTop < triggerPoint && containerBottom > scrollTop) {
          $container.addClass("animate-video");
          if ($video && $video.paused) {
            $video.play().catch((e) => {});
          }
        } else {
          $container.removeClass("animate-video");
          if ($video && !$video.paused) {
            $video.pause();
          }
        }
      });
    }

    $(window).on("scroll resize", handleVideoPlaybackOnScroll);

    handleVideoPlaybackOnScroll();

    $(window).on("scroll", function () {
      if ($(window).scrollTop() === 0) {
        $targetParagraphs.each(function () {
          $(this).removeClass("animate-video");
          const $video = $(this).find("video").get(0);
          if ($video) {
            $video.pause();
          }
        });
      }
    });
  });

  // $(document).ready(function () {
  //   $(".has-animation .paragraph__wrapper").each(function () {
  //     const $wrapper = $(this);
  //     const $rows = $wrapper.find(".views-row");

  //     const rowPairs = [];
  //     for (let i = 0; i < $rows.length; i += 2) {
  //       rowPairs.push($rows.slice(i, i + 2));
  //     }

  //     function animateVisibleRowPairs() {
  //       const windowHeight = $(window).height();
  //       const scrollTop = $(window).scrollTop();

  //       rowPairs.forEach(($pair) => {
  //         const $firstRow = $pair.first();
  //         const rowTop = $firstRow.offset().top;

  //         if (scrollTop + windowHeight - 600 > rowTop) {
  //           $pair.addClass("animate-rows");
  //         } else {
  //           $pair.removeClass("animate-rows");
  //         }
  //       });
  //     }

  //     $(window).on("scroll resize", animateVisibleRowPairs);
  //     animateVisibleRowPairs();
  //   });
  // });

  $(document).ready(function () {
    $(".has-animation .paragraph__wrapper").each(function () {
      const $wrapper = $(this);
      const $rows = $wrapper.find(".views-row");

      function animateVisibleRows() {
        const windowHeight = $(window).height();
        const scrollTop = $(window).scrollTop();
        const isMobile = window.innerWidth < 768;
        const triggerOffset = isMobile ? 350 : 600;

        $rows.each(function () {
          const $row = $(this);
          const rowTop = $row.offset().top;
          const rowBottom = rowTop + $row.outerHeight();

          const triggerPoint = scrollTop + windowHeight - triggerOffset;

          if (rowTop < triggerPoint && rowBottom > scrollTop) {
            $row.addClass("animate-rows");
          } else {
            $row.removeClass("animate-rows");
          }
        });
      }

      $(window).on("scroll resize", animateVisibleRows);
      animateVisibleRows();
    });

    //Child services component video animation on scroll
    $(".taxonomy-term--services").each(function () {
      // Autoplay is only allowed when the muted *property* is true
      $("video").each(function () {
        $(this)
          .attr("muted", true)
          .attr("autoplay", true)
          .attr("playsinline", true)
          .attr("preload", "auto")
          .prop({ muted: true, autoplay: true, playsInline: true });
      });

      $(".taxonomy__top .field-field-media video").each(function () {
        this.play().catch((e) => {});
      });

      const $term = $(this);
      const $items = $term.find(".child_teaser--content");

      function animateVisibleItems() {
        const windowHeight = $(window).height();
        const scrollTop = $(window).scrollTop();
        const isMobile = window.innerWidth < 768;
        const triggerOffset = isMobile ? 200 : 400;

        $items.each(function () {
          const $item = $(this);
          const itemTop = $item.offset().top;
          const itemBottom = itemTop + $item.outerHeight();
          const triggerPoint = scrollTop + windowHeight - triggerOffset;

          if (itemTop < triggerPoint && itemBottom > scrollTop) {
            $item.addClass("animate-rows");

            // Play video if present and paused
            const $video = $item.find("video").get(0);
            if ($video && $video.paused) {
              $video.play().catch((e) => {});
            }
          } else {
            const $video = $item.find("video").get(0);
            if ($video && !$video.paused) {
              $video.pause();
            }
          }
        });
      }

      $(window).on("scroll resize", animateVisibleItems);
      animateVisibleItems();
    });

    $(window).on("scroll", function () {
      if ($(window).scrollTop() === 0) {
        $(".taxonomy-term--services .child_teaser--content").each(function () {
          $(this).removeClass("animate-rows");
          const $video = $(this).find("video").get(0);
          if ($video) {
            $video.pause();
          }
        });
      }
    });
  });

  /* 
  | ----------------------------
  | GSAP Animations 
  | ----------------------------
  */
  $(function () {
    gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

    // Services page hero banner
    if ($(".taxonomy__top.has-media").length) {
      $("html").css("scroll-behavior", "auto");

      const heroSelector = ".taxonomy__top.has-media";
      const heroMedia =
        ".taxonomy__top.has-media .field-field-media .field-field-media-video-file, .taxonomy__top.has-media .field-field-media img";

      // Linear ease + numeric scrub: the motion follows the scroll evenly
      // and catches up smoothly instead of jumping with each wheel step.
      const heroParallax = (y, scale) => {
        const tl = gsap.timeline({
          defaults: { ease: "none", force3D: true },
          scrollTrigger: {
            trigger: heroSelector,
            start: "top top",
            end: "bottom top",
            scrub: 0.8,
            invalidateOnRefresh: true,
          },
        });

        tl.to(heroSelector, { y: y }, 0).to(heroMedia, { scale: scale }, 0);
      };

      const heroMm = gsap.matchMedia();
      heroMm.add("(min-width: 1026px)", () => heroParallax(-350, 1.8));
      heroMm.add("(max-width: 1025px)", () => heroParallax(-100, 1.2));

      $(window).on("load", function () {
        ScrollTrigger.refresh();
      });
    }

    //Anchor links smooth scroll if gsap present
    $(document).ready(function () {
      $('a[href^="#"]').on("click", function (e) {
        e.preventDefault();

        const id = $(this).attr("href");
        const $target = $(id);
        if (!$target.length) return;

        const offset = 80;
        const targetY = $target.offset().top - offset;

        const scrollTriggers = ScrollTrigger.getAll();

        scrollTriggers.forEach((st) => {
          if (st.vars.snap || st.vars.pin) st.disable();
        });

        gsap.to(window, {
          scrollTo: {
            y: targetY,
            autoKill: false,
          },
          duration: 1,
          ease: "power2.out",
          overwrite: "auto",
          onComplete: () => {
            scrollTriggers.forEach((st) => {
              if (st.vars.snap || st.vars.pin) st.enable();
            });
          },
        });
      });
    });
  });

  // Milestones component
  // Each card collapses to its title as it moves up past the middle of the
  // viewport and expands again on the way back. The collapse is tied to the
  // scroll position (not a one-off toggle), so it follows the scroll exactly
  // in both directions and works with native touch/momentum scrolling.
  $(function () {
    $(window).on("load", function () {
      const list = document.querySelector(
        ".paragraph--type--milestones > .field__items",
      );

      if (!list) return;

      // Fraction of the viewport the card's full-height bottom edge must
      // scroll up past before it starts collapsing.
      const START_DESKTOP = 0.35;
      const START_MOBILE = 0.6;
      const MIN_RANGE = 0.25; // collapse over at least 25% of the viewport height
      // Scroll distance of the collapse, relative to the content's height.
      const RANGE_DESKTOP = 1.4;
      const RANGE_MOBILE = 1.6;
      // Per-frame catch-up towards the scroll position; 1 = no smoothing.
      // Closing (scrolling down) eases in more gently than reopening.
      const SMOOTHING_CLOSE = 0.07;
      const SMOOTHING_OPEN = 0.16;
      const reduceMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)",
      ).matches;
      const ease = gsap.parseEase("sine.inOut");
      const clamp = gsap.utils.clamp(0, 1);

      const items = Array.from(list.children)
        .map((item) => {
          const card = item.querySelector(".paragraph--type--milestone");
          const wrapper = item.querySelector(".paragraph__wrapper");
          if (!card || !wrapper) return null;

          return {
            card,
            wrapper,
            gap: parseFloat(getComputedStyle(wrapper).marginTop) || 0,
            progress: 0, // 0 = open, 1 = collapsed
          };
        })
        .filter(Boolean);

      if (!items.length) return;

      gsap.set(
        items.map((item) => item.wrapper),
        { overflow: "hidden" },
      );

      // The browser's scroll anchoring would try to "fix" the height changes
      // by moving the scroll position, which fights the animation.
      document.documentElement.style.overflowAnchor = "none";

      const render = (item) => {
        const shown = 1 - item.progress;

        if (shown >= 1) {
          gsap.set(item.wrapper, { clearProps: "height,marginTop,opacity" });
          return;
        }

        gsap.set(item.wrapper, {
          height: item.wrapper.scrollHeight * shown,
          marginTop: item.gap * shown,
          opacity: clamp(1 - item.progress * 1.6),
        });
      };

      // Where the card's bottom edge would be if it were fully open. A card's
      // top isn't affected by its own collapse, so this doesn't feed back
      // into itself.
      const targetFor = (item, vh) => {
        const full = item.wrapper.scrollHeight + item.gap;
        const openBottom =
          item.card.getBoundingClientRect().bottom + full * item.progress;
        const desktop = window.innerWidth > 1025;
        const range = Math.max(
          full * (desktop ? RANGE_DESKTOP : RANGE_MOBILE),
          vh * MIN_RANGE,
        );
        // Near the top of the page every card stays open.
        const topGuard = clamp(window.scrollY / (vh * 0.25));

        const start = desktop ? START_DESKTOP : START_MOBILE;

        return ease(clamp((vh * start - openBottom) / range)) * topGuard;
      };

      let dirty = true;
      let snap = true;
      let changed = false;
      let refreshTimer;

      const tick = () => {
        if (!dirty) return;

        const vh = window.innerHeight;
        const frames = gsap.ticker.deltaRatio(60);
        const factor = (smoothing) =>
          snap || reduceMotion ? 1 : 1 - Math.pow(1 - smoothing, frames);
        let settled = true;

        // Top to bottom, so each card is measured after the cards above it
        // have been updated for this frame.
        items.forEach((item) => {
          const target = targetFor(item, vh);
          const diff = target - item.progress;

          if (Math.abs(diff) < 0.001) {
            if (item.progress === target) return;
            item.progress = target;
          } else {
            item.progress +=
              diff * factor(diff > 0 ? SMOOTHING_CLOSE : SMOOTHING_OPEN);
            settled = false;
          }

          render(item);
          changed = true;
        });

        snap = false;

        if (settled) {
          dirty = false;

          // Let other ScrollTriggers on the page pick up the new layout.
          if (changed) {
            changed = false;
            clearTimeout(refreshTimer);
            refreshTimer = setTimeout(() => {
              if (!dirty) ScrollTrigger.refresh();
            }, 300);
          }
        }
      };

      const wake = () => {
        dirty = true;
      };

      window.addEventListener("scroll", wake, { passive: true });
      window.addEventListener("resize", wake);
      gsap.ticker.add(tick);
    });
  });
  /*
  | ----------------------------
  | Paragraph components
  | ----------------------------
  */

  //Accordion
  if ($(".accordion").length) {
    $(".accordion .accordion__item .field__label").on("click", function () {
      $(this).parents(".accordion .accordion__item").toggleClass("show");
    });
  }

  //Tabs
  if ($(".tabs").length) {
    $(".tabs__item .field__label").on("click", function () {
      if ($(window).width() > 1024) {
        $(".tabs__item").removeClass("active");
        $(this).parents(".tabs__item").addClass("active");
      } else {
        $(this).parents(".tabs__item").toggleClass("active");
      }
    });
  }

  $(function ($) {
    $(
      ".paragraph--type--full-width-media.no-autoplay .field-field-media-video-file video",
    ).each(function () {
      const $video = $(this);

      const $playButton = $('<div class="custom-play-button"></div>');

      $video.parent().append($playButton);

      $playButton.on("click", function () {
        if ($video[0].paused) {
          $video[0].play();
          $playButton.hide();
        } else {
          $video[0].pause();
          $playButton.show();
        }
      });

      $video.on("ended", function () {
        $playButton.show();
      });
    });

    $(
      ".paragraph--type--full-width-media.autoplay .field-field-media-video-file video",
    ).each(function () {
      $(this)
        .prop({
          autoplay: true,
          loop: true,
          muted: true,
          playsinline: true,
        })
        .removeAttr("controls")[0]
        .play();
    });

    $(
      ".node--type-case-study.full .case__top--video .field-field-video .field-field-media-video-file video",
    ).each(function () {
      $(this)
        .prop({
          autoplay: true,
          loop: true,
          muted: true,
          playsinline: true,
        })
        .removeAttr("controls")[0]
        .play();
    });

    $(
      ".path-taxonomy .field-field-media video, .view-blog.view-display-block_3>.view-content>.views-row .promoted-teaser .field-field-video video, .view-taxonomy_term .taxonomy__top .field-field-media video, .view-taxonomy_term .taxonomy__top .field-field-responsive-media video, .page-node-type-page .page-title-container video",
    ).each(function () {
      $(this)
        .prop({
          autoplay: true,
          loop: true,
          muted: true,
          playsinline: true,
        })
        .removeAttr("controls")[0]
        .play();
    });

    $(
      ".view-taxonomy_term video, .paragraph--type--text-on-both-sides video, .paragraph--type--full-width-media .field-field-media-video-file video",
    ).each(function () {
      const video = $(this);

      // Set attributes and properties
      video
        .attr("muted", "muted")
        .attr("autoplay", "autoplay")
        .attr("playsinline", "playsinline")
        .attr("preload", "auto")
        .prop({
          autoplay: true,
          loop: true,
          muted: true,
          playsinline: true,
        })
        .removeAttr("controls");

      // Force play with error handling
      const videoElement = video[0];
      const playPromise = videoElement.play();

      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          // console.log("Autoplay failed for video:", error);

          // Fallback: play on first user interaction
          const playOnInteraction = () => {
            videoElement
              .play()
              .catch((e) => console.log("Manual play failed:", e));
            document.removeEventListener("touchstart", playOnInteraction);
            document.removeEventListener("click", playOnInteraction);
          };

          document.addEventListener("touchstart", playOnInteraction, {
            once: true,
          });
          document.addEventListener("click", playOnInteraction, { once: true });
        });
      }
    });

    $(".path-taxonomy .child_teaser--content .field-field-icon video").each(
      function () {
        $(this)
          .prop({
            loop: true,
            muted: true,
            playsinline: true,
          })
          .removeAttr("controls");

        // $(this)
        //   .on("mouseenter", function () {
        //     this.play();
        //   })
        //   .on("mouseleave", function () {
        //     this.pause();
        //   });

        $(this)
          .closest(".child_teaser--content")
          .on("mouseenter", function () {
            $(this).find("video")[0].play();
          })
          .on("mouseleave", function () {
            $(this).find("video")[0].pause();
          });
      },
    );

    $(".paragraph--type--table.red-text").each(function () {
      $(this).find("a.cta").attr("target", "_blank");
    });
  });

  // $(function ($) {
  //   $(".paragraph--type--single-link .paragraph__wrapper").hover(
  //     function () {
  //       const hoverElement = $(this).find(".paragraph__wrapper--hover");

  //       hoverElement
  //         .stop(true, true)
  //         .css({ display: "flex", left: "-150%" })
  //         .animate({ left: "40px" }, 1500, "swing", function () {
  //           $(this).animate({ left: "0px" }, 1700, "swing");
  //         });
  //     },
  //     function () {
  //       const hoverElement = $(this).find(".paragraph__wrapper--hover");

  //       hoverElement
  //         .stop(true, true)
  //         .animate({ left: "-150%" }, 1200, "swing", function () {
  //           $(this).css("display", "none");
  //         });
  //     }
  //   );
  // });

  $(function ($) {
    $.easing.easeOutBack = function (x, t, b, c, d, s) {
      if (s == undefined) s = 1.70158;
      return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
    };

    $(".paragraph--type--single-link .paragraph__wrapper").hover(
      function () {
        const hoverElement = $(this).find(".paragraph__wrapper--hover");

        hoverElement
          .stop(true, true)
          .css({
            display: "flex",
            left: "-150%",
            transition: "none",
          })
          .animate({ left: "40px" }, 1400, "linear")
          .animate({ left: "0px" }, 1400, "easeOutBack");
      },
      function () {
        const hoverElement = $(this).find(".paragraph__wrapper--hover");

        hoverElement
          .stop(true, true)
          .css({ transition: "none" })
          .animate({ left: "-150%" }, 1200, "swing", function () {
            $(this).css("display", "none");
          });
      },
    );
  });

  // (function () {
  //   function init() {
  //     const singleLinkElements = document.querySelectorAll(
  //       ".paragraph--type--single-link .paragraph__wrapper"
  //     );

  //     singleLinkElements.forEach((wrapper) => {
  //       const hoverElement = wrapper.querySelector(
  //         ".paragraph__wrapper--hover"
  //       );

  //       if (!hoverElement) return;

  //       gsap.set(hoverElement, {
  //         display: "none",
  //         left: "-150%",
  //         opacity: 0,
  //       });

  //       wrapper.addEventListener("mouseenter", () => {
  //         gsap.killTweensOf(hoverElement);

  //         const tl = gsap.timeline();

  //         tl.set(hoverElement, {
  //           display: "flex",
  //         })
  //           .to(hoverElement, {
  //             left: "40px",
  //             opacity: 1,
  //             duration: 1.2,
  //             ease: "power2.out",
  //           })
  //           .to(hoverElement, {
  //             left: "0px",
  //             duration: 0.9,
  //             ease: "power1.inOut",
  //           });
  //       });

  //       wrapper.addEventListener("mouseleave", () => {
  //         gsap.killTweensOf(hoverElement);

  //         gsap.to(hoverElement, {
  //           left: "-150%",
  //           opacity: 0,
  //           duration: 0.7,
  //           ease: "power2.in",
  //           onComplete: () => {
  //             gsap.set(hoverElement, { display: "none" });
  //           },
  //         });
  //       });
  //     });
  //   }

  //   if (document.readyState === "loading") {
  //     document.addEventListener("DOMContentLoaded", init);
  //   } else {
  //     init();
  //   }
  // })();

  //Contact map functionality
  (function (Drupal, once) {
    Drupal.behaviors.geofieldMap = {
      attach: function (context, settings) {
        once("geofieldMap", "#map", context).forEach(function (mapContainer) {
          const nodeId = $(".location-title").data("location-id");
          const lat = $(".location-title").data("lat");
          const lng = $(".location-title").data("lng");

          var styledMapType = new google.maps.StyledMapType(
            [
              {
                featureType: "all",
                elementType: "labels.text.fill",
                stylers: [
                  {
                    saturation: 36,
                  },
                  {
                    color: "#000000",
                  },
                  {
                    lightness: 40,
                  },
                ],
              },
              {
                featureType: "all",
                elementType: "labels.text.stroke",
                stylers: [
                  {
                    visibility: "on",
                  },
                  {
                    color: "#000000",
                  },
                  {
                    lightness: 16,
                  },
                ],
              },
              {
                featureType: "all",
                elementType: "labels.icon",
                stylers: [
                  {
                    visibility: "off",
                  },
                ],
              },
              {
                featureType: "administrative",
                elementType: "geometry.fill",
                stylers: [
                  {
                    color: "#000000",
                  },
                  {
                    lightness: 20,
                  },
                ],
              },
              {
                featureType: "administrative",
                elementType: "geometry.stroke",
                stylers: [
                  {
                    color: "#000000",
                  },
                  {
                    lightness: 17,
                  },
                  {
                    weight: 1.2,
                  },
                ],
              },
              {
                featureType: "landscape",
                elementType: "geometry",
                stylers: [
                  {
                    color: "#000000",
                  },
                  {
                    lightness: 20,
                  },
                ],
              },
              {
                featureType: "poi",
                elementType: "geometry",
                stylers: [
                  {
                    color: "#000000",
                  },
                  {
                    lightness: 21,
                  },
                ],
              },
              {
                featureType: "road.highway",
                elementType: "geometry.fill",
                stylers: [
                  {
                    color: "#000000",
                  },
                  {
                    lightness: 17,
                  },
                ],
              },
              {
                featureType: "road.highway",
                elementType: "geometry.stroke",
                stylers: [
                  {
                    color: "#000000",
                  },
                  {
                    lightness: 29,
                  },
                  {
                    weight: 0.2,
                  },
                ],
              },
              {
                featureType: "road.arterial",
                elementType: "geometry",
                stylers: [
                  {
                    color: "#000000",
                  },
                  {
                    lightness: 18,
                  },
                ],
              },
              {
                featureType: "road.local",
                elementType: "geometry",
                stylers: [
                  {
                    color: "#000000",
                  },
                  {
                    lightness: 16,
                  },
                ],
              },
              {
                featureType: "transit",
                elementType: "geometry",
                stylers: [
                  {
                    color: "#000000",
                  },
                  {
                    lightness: 19,
                  },
                ],
              },
              {
                featureType: "water",
                elementType: "geometry",
                stylers: [
                  {
                    color: "#000000",
                  },
                  {
                    lightness: 17,
                  },
                ],
              },
            ],
            {
              name: "Styled Map",
            },
          );

          const map = new google.maps.Map(mapContainer, {
            center: { lat: parseFloat(lat), lng: parseFloat(lng) },
            zoom: 18,
            mapTypeControlOptions: {
              mapTypeIds: [
                "roadmap",
                "satellite",
                "hybrid",
                "terrain",
                "styled_map",
              ],
            },
          });

          map.mapTypes.set("styled_map", styledMapType);
          map.setMapTypeId("styled_map");

          $(
            ".view-office_locations.view-display-block_2 .view-content>.views-row",
          )
            .first()
            .addClass("active");

          $(".location-title").each(function () {
            const markerLat = parseFloat($(this).data("lat"));
            const markerLng = parseFloat($(this).data("lng"));
            const markerNodeId = $(this).data("location-id");

            const marker = new google.maps.Marker({
              position: { lat: markerLat, lng: markerLng },
              map: map,
              icon: "/themes/custom/rkpt/assets/image/icon/map-pin.png",
              // "data-nid": markerNodeId,
            });

            // marker.addListener("click", () => {
            //   console.log("Marker clicked:", markerNodeId);
            // });
          });

          $(".location-title").click(function (e) {
            e.preventDefault();

            $(this)
              .closest(".views-row")
              .addClass("active")
              .siblings()
              .removeClass("active");

            const nodeId = $(this).data("location-id");
            const lat = $(this).data("lat");
            const lng = $(this).data("lng");

            const center = new google.maps.LatLng(
              parseFloat(lat),
              parseFloat(lng),
            );
            map.panTo(center);

            // const targetLat = parseFloat(lat);
            // const targetLng = parseFloat(lng);

            // markers.forEach(function (marker) {
            //   const markerLat = marker.getPosition().lat();
            //   const markerLng = marker.getPosition().lng();

            //   if (markerLat === targetLat && markerLng === targetLng) {
            //     marker.toggleClass("bouncing-marker");
            //   }
            // });

            // $('[role="button"]')
            //   .parent()
            //   .children()
            //   .removeClass("scaled-marker");

            // $('[role="button"]').each(function () {
            //   const markerNid = $(this).attr("aria-label");
            //   if (markerNid == nodeId) {
            //     $(this).addClass("scaled-marker");
            //     return false;
            //   }
            // });
          });
        });
      },
    };
  })(Drupal, once);

  $(document).ready(function ($) {
    $(".anchor-menu").each(function () {
      if ($(this).find(".paragraph--type--link-only").children().length) {
        $(this).addClass("margin");
      }
    });
  });

  //BEF mobile list
  (function ($) {
    $(document).ready(function () {
      var $container = $(
        ".view-case_studies .bef-links, .view-blog .bef-links",
      );

      var activeText = $.trim($container.find("a.bef-link--selected").text());

      if (!activeText || activeText === "All") {
        if ($container.closest(".view-blog").length) {
          activeText = "All News";
        } else if ($container.closest(".view-case_studies").length) {
          activeText = "All Case Studies";
        }
      }

      var $mobileBtn = $(
        '<button type="button" class="mobile-filter-trigger">' +
          activeText +
          '<span class="arrow"></span></button>',
      );

      if ($container.find(".mobile-filter-trigger").length === 0) {
        $container.prepend($mobileBtn);
      }

      $container.on("click", ".mobile-filter-trigger", function () {
        $(this).toggleClass("is-open");
        $(this).siblings("ul").slideToggle(200);
      });

      $(window).resize(function () {
        if ($(window).width() >= 768) {
          $container.find("ul").show();
          $container.find(".mobile-filter-trigger").hide();
        } else {
          if (!$container.find(".mobile-filter-trigger").hasClass("is-open")) {
            $container.find("ul").hide();
          }
          $container.find(".mobile-filter-trigger").css("display", "flex");
        }
      });

      $(window).trigger("resize");
    });
  })(jQuery);

  //Clients
  $(document).ready(function () {
    const $toggleButton = $("#toggle-clients");
    const $clientContainer = $(".view-content");

    const initialCount = 20;

    const $hiddenClients = $clientContainer.find(
      ".views-row:nth-child(n+" + (initialCount + 1) + ")",
    );

    if ($hiddenClients.length === 0) {
      $toggleButton.hide();
      return;
    }

    let isShowingAll = false;

    $toggleButton.on("click", function (e) {
      e.preventDefault();

      if (!isShowingAll) {
        $clientContainer
          .find(".views-row:nth-child(n+" + (initialCount + 1) + ")")
          .each(function (index) {
            $(this)
              .css({
                display: "inline-block",
                opacity: 0,
              })
              .delay(index * 50)
              .animate({ opacity: 1 }, 300);
          });

        $toggleButton.text("See less");
        isShowingAll = true;
      } else {
        $clientContainer
          .find(".views-row:nth-child(n+" + (initialCount + 1) + ")")
          .fadeOut(200, function () {
            $(this).css("opacity", 0);
          });

        $toggleButton.text("See all");
        isShowingAll = false;

        const clientSectionTop =
          $clientContainer.closest(".view-clients").offset().top + 600;

        console.log(clientSectionTop);

        $("html, body").animate(
          {
            scrollTop: clientSectionTop,
          },
          800,
        );
      }
    });
  });
})(jQuery, Drupal, drupalSettings);
